export default __webpack_public_path__ + "dropdown-arrow-white.svg";